import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

interface PageProps {
  data: {
    page: {
      title?: string
      path?: string
      seo: any
      flexContent: any
      databaseId: number
    }
  }
  location?: any
  prefix?: string
  pageContext: any
}

const PageTemplate: React.FC<PageProps> = ({
  data: {
    page: { title, flexContent, seo, databaseId },
  },
  location = {},
  prefix = 'Page_Flexcontent',
  pageContext,
}) => (
  <Layout title={title}>
    <SEO seo={seo} id={databaseId} />
    <FlexContentHandler
      prefix={prefix}
      fields={flexContent}
      location={location}
      pageContext={pageContext}
    />
  </Layout>
)

export const pageQuery = graphql`
  query pageById($pageId: String!) {
    page: wpPage(id: { eq: $pageId }) {
      ...generalPageFragment
    }
  }
`

export default PageTemplate
